document.addEventListener('DOMContentLoaded', function() {
  function resizeVideoGallery(selector) {
    const swiperSlider = document.querySelectorAll(selector);

    swiperSlider.forEach(function (swiperEl) {
      const swiperGallery = new Swiper(swiperEl, {
        slidesPerView: 1.1,
        spaceBetween: 20,
        direction: "horizontal",
        loop: true,
        pagination: {
          el: swiperEl.querySelector("._js-gallery-video-slider-pagination"),
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          834: {
            slidesPerView: "auto",
          },
        },
        navigation: {
          nextEl: swiperEl.closest('._js-gallery-video-container').querySelector("._js-gallery-video-slider-arrows-next"),
          prevEl: swiperEl.closest('._js-gallery-video-container').querySelector("._js-gallery-video-slider-arrows-prev"),
        },
      });
    });
  }

  resizeVideoGallery("._js-gallery-video-slider");
});
